import { useRouter } from 'next/router';

import { Log, useUBL } from '@common/log-manager';
import { useEnvConfig } from '@domains/storehome-common';

interface Params {
  log?: Partial<Log>;
}

export const useLookbookService = ({ log }: Params) => {
  const { is_zigzag } = useEnvConfig();
  const router = useRouter();
  const tracker = useUBL();

  const moveToCollectionPage = (link_url?: string | null) => {
    if (!link_url) {
      return;
    }

    if (log != null) {
      tracker({
        ...log,
        navigation: 'shop_detail',
        object_type: 'image',
        category: 'click',
      });
    }

    // 일단 앱 랜딩을 통해 처리하기로 하고 아래의 코드 주석처리(https://croquis.atlassian.net/browse/SELFE-1565). by lucas
    const match = /.+url=(.+)/.exec(link_url);

    if (!match) {
      return;
    }

    const collection_detail_url = match[1];

    if (!collection_detail_url) {
      return;
    }

    if (is_zigzag) {
      return router.push(collection_detail_url);
    }

    router.push(collection_detail_url.replace('store.', ''));
  };

  return {
    moveToCollectionPage,
  };
};
